module.exports = __webpack_public_path__ + "img/ZHWLRJKF_1.1a94499c.jpg";